import React from "react";
import imgone from "../../assets/img/banbury.webp";
import imgTwo from "../../assets/img/cheltenham.jpg";
import imgThree from "../../assets/img/worcester.jpg";
const InvisalignSmileView = () => {
  return (
    <div className="container-fluid py-5">
      <h2 className="text-center fs-40 mb-4">Invisalign® Smile View</h2>
      <div className="row align-items-center gap-lg-0 gap-4 mb-4">
        <div className="col-lg-6 px-lg-5">
          <img
            src={imgone}
            className="w-100 h-auto"
            alt="smileView"
            loading="lazy"
          />
        </div>
        <div className="col-lg-6">
          <div className="row">
            <div className="col-md-6">
              <img
                src={imgTwo}
                className="w-100 h-auto rounded-circle"
                alt="Before Invisalign Treatment"
                loading="lazy"
              />
              <p class="mt-3 text-center">
                <strong>Before</strong>
              </p>
            </div>
            <div className="col-md-6">
              <img
                src={imgThree}
                className="w-100 h-auto rounded-circle"
                alt="After Invisalign Treatment"
                loading="lazy"
              />
              <p class="mt-3 text-center">
                <strong>After</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <a
          href="https://www.invisalign.co.uk/SV/1807260"
          target="blank"
          className="btn btn-golden fs-14"
        >
          Take the Smile Assessment
        </a>
      </div>
    </div>
  );
};

export default InvisalignSmileView;
